import React, { useState, useEffect} from "react";
import "../style/dashboard.css";
import { Row, Col, Card, Table, Pagination, Alert, Spinner } from "react-bootstrap";
import HelperFunction from '../util/helper'
import { TIME_FORMAT_OPTIONS } from '../util/constants'
import APIFunction from "../util/api";

export default function Notifications({ preview = false }) {
    const [notifications, setNotifications] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');

    const fetchNotifications = async (page) => {
        try {
          setIsLoading(true);
          setError('');
    
          const response = await APIFunction.getNotifications(page)
        
          setNotifications(response);
          //setTotalPages(response.pagination.totalPages);
        } catch (err) {
          setError(err.message);
        } finally {
          setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchNotifications(currentPage);
    }, [currentPage]);
    
    const handlePageChange = (page) => {
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    return(
        <Row>
            <Col>
                {error && <Alert variant="danger">{error}</Alert>}
                <Card className="transactions-card">
                    <Card.Body>
                        <div className="card-header-custom">
                            <h5><i className="bi bi-bell"></i> Notifications</h5>
                            <select className="filter-select">
                                <option>This Month</option>
                                <option>This Week</option>
                                <option>Today</option>
                            </select>
                        </div>
                        {isLoading ? (
                                <div className="d-flex justify-content-center my-5">
                                    <Spinner animation="border" />
                                </div>
                            ) : (
                                <>
                                    <Table responsive className="transactions-table">
                                        <thead>
                                        <tr>
                                            <th>Title</th>
                                            <th>Date & Time</th>
                                            <th>Note</th>
                                            <th>Status</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {notifications.length > 0 ? (
                                            notifications.map(notification => (
                                                <tr key={notifications.id}>
                                                <td>
                                                    <div className="transaction-info">
                                                        <strong>{notification.title}</strong>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="date-time">
                                                    <div>{HelperFunction.formatDate(notification.created_at, TIME_FORMAT_OPTIONS.DATE_MONTH_YEAR_OPTIONS)}</div>
                                                    <small className="text-muted">{HelperFunction.formatDate(notification.created_at, TIME_FORMAT_OPTIONS.TIME_OPTIONS)}</small>
                                                    </div>
                                                </td>
                                                <td className="note-cell">{HelperFunction.truncateString(notification.message) ?? 'N/A'}</td>
                                                <td>{HelperFunction.getStatusBadge(notification.priority)}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="5" className="text-center">
                                                    No notifications.
                                                </td>
                                            </tr>
                                        )}
                                        </tbody>
                                    </Table>

                                    {/* Pagination only if preview === true */}
                                    {!preview && (
                                        <div className="d-flex justify-content-center">
                                            <Pagination>
                                                <Pagination.Prev
                                                    onClick={() => handlePageChange(currentPage - 1)}
                                                    disabled={currentPage === 1}
                                                />
                                                {Array.from({ length: totalPages }, (_, index) => (
                                                    <Pagination.Item
                                                    key={index + 1}
                                                    active={index + 1 === currentPage}
                                                    onClick={() => handlePageChange(index + 1)}
                                                    >
                                                    {index + 1}
                                                    </Pagination.Item>
                                                ))}
                                                <Pagination.Next
                                                    onClick={() => handlePageChange(currentPage + 1)}
                                                    disabled={currentPage === totalPages}
                                                />
                                            </Pagination>
                                        </div>)
                                    }
                                </>
                            )}
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    )
}